const ssoRoute = {
  auth: {
    login: "/login",
    forgot_password: "/forgot-password",
    reset_password: "/reset-password",
  },
  apps: {
    apps: "/app",
  },
  company: {
    select_company: "/select-company",
  },
};

const client = {
  dashboard: {
    dashboard: "/",
  },
  users: {
    companies: {
      listing: "/companies",
      create: "/companies/create",
      edit: "/companies/:company_id/edit",
      profile: {
        details: "/companies/:company_id",
        business_units: {
          listing: "/companies/:company_id/business-units",
          regions: "/companies/:company_id/business-units/:business_unit_id",
          countries:
            "/companies/:company_id/business-units/:business_unit_id/:region_id",
          legal_entities:
            "/companies/:company_id/business-units/:business_unit_id/:region_id/:country_id",
        },

        regions: "/companies/:company_id/regions",
      },
    },
    company_users: {
      company_user: "/company-users",
      listing: "/company-users/list/:company_id",
      create: "/company-users/create/:company_id",
      edit: "/company-users/edit/:company_user_id/company/:company_id",
    },
  },
  settings: {
    // JF Work
    company_job_function: {
      listing: "/company-job-functions/",
      listingByCompanyId: "/company-job-functions/company/:company_id",
      company_sub_job_function:
        "/company-job-functions/company/:company_id/job_function/:job_id",
    },
  },
};

const admin = {
  dashboard: {
    dashboard: "/",
  },
  users: {
    companies: {
      listing: "/companies",
      create: "/companies/create",
      edit: "/companies/:company_id/edit",
      profile: {
        details: "/companies/:company_id",
        business_units: {
          listing: "/companies/:company_id/business-units",
          regions: "/companies/:company_id/business-units/:business_unit_id",
          countries:
            "/companies/:company_id/business-units/:business_unit_id/:region_id",
          legal_entities:
            "/companies/:company_id/business-units/:business_unit_id/:region_id/:country_id",
        },

        regions: "/companies/:company_id/regions",
      },
    },
    company_users: {
      company_user: "/company-users",
      listing: "/company-users/list/:company_id",
      create: "/company-users/create/:company_id",
      edit: "/company-users/edit/:company_user_id/company/:company_id",
    },
  },

  settings: {
    tom_users: {
      listing: "/tom-users",
      create: "/tom-users/create",
      edit: "/tom-users/edit/:tom_user_id",
    },
    sectors: {
      listing: "/sectors",
      industry: "/sectors/:sector_id",
      sub_industry: "/sectors/:sector_id/:industry_id",
    },
    job_function: {
      listing: "/job-functions",
      sub_job_function: "/job-functions/:job_id",
    },
    grade_map_table: {
      listing: "/grade-map-table",
      create_grade_company: "/grade-map-table/create-grade-company",
      edit_grade_company: "/grade-map-table/edit-grade-company",
    },
    // JF Work
    company_job_function: {
      listing: "/company-job-functions/",
      listingByCompanyId: "/company-job-functions/company/:company_id",
      company_sub_job_function:
        "/company-job-functions/company/:company_id/job_function/:job_id",
    },
    company_functions_map_table: {
      listing: "/company-functions-map-table",
      // create_grade_company: "/grade-map-table/create-grade-company",
      // edit_grade_company: "/grade-map-table/edit-grade-company",
    },
  },
};

export { ssoRoute, admin, client };
